import { Grid } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { VisitStatFilter, VisitStats } from 'v2/pages/Visits/utils/visitStats';
import StatTile from './StatTile';

const STAT_TILE_GRID_SIZE = { xs: 6, sm: 3 };

interface Props {
  stats: VisitStats;
  isLoading: boolean;
  selectedStat: VisitStatFilter;
  onStatClick: (stat: VisitStatFilter) => void;
}

const VisitStatTiles: React.FC<Props> = ({ stats, isLoading, selectedStat, onStatClick }) => {
  const { translation } = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid size={STAT_TILE_GRID_SIZE}>
        <StatTile
          value={stats.totalExpected}
          label={translation.total_expected}
          isLoading={isLoading}
          stat={VisitStatFilter.TotalExpected}
          selectedStat={selectedStat}
          onStatClick={onStatClick}
        />
      </Grid>

      <Grid size={STAT_TILE_GRID_SIZE}>
        <StatTile
          value={stats.today}
          label={translation.today}
          isLoading={isLoading}
          stat={VisitStatFilter.Today}
          selectedStat={selectedStat}
          onStatClick={onStatClick}
        />
      </Grid>

      <Grid size={STAT_TILE_GRID_SIZE}>
        <StatTile
          value={stats.tomorrow}
          label={translation.tomorrow}
          isLoading={isLoading}
          stat={VisitStatFilter.Tomorrow}
          selectedStat={selectedStat}
          onStatClick={onStatClick}
        />
      </Grid>

      <Grid size={STAT_TILE_GRID_SIZE}>
        <StatTile
          value={stats.next7Days}
          label={translation.next_7_days}
          isLoading={isLoading}
          stat={VisitStatFilter.Next7Days}
          selectedStat={selectedStat}
          onStatClick={onStatClick}
        />
      </Grid>
    </Grid>
  );
};

export default VisitStatTiles;
